import React from 'react';
import TablePayment from 'slickpay/common/TablePayment.component';
import FaqItem from 'slickpay/online/FaqItem.component';

import ExternalLink from 'components/generic/ExternalLink.component';
import { useTranslation } from 'providers/GILT.provider';
import { useSalonGilt } from 'providers/SalonBasicInfo.provider';

import CN from './FaqTips.module.scss';

const VIDEO_LINK = 'https://www.youtube.com/watch?v=FwfNswZ76xU&ab_channel=Slick';

const FaqTips = () => {
  const { t } = useTranslation();
  const { isSalonWithGDPR } = useSalonGilt();

  const renderDescription = ({ description, children }) => {
    if (children) {
      return (
        <div>
          <div className={CN.description}>{description}</div>
          {children}
        </div>
      );
    }
    return <div className={CN.description}>{description}</div>;
  };

  const renderDescriptionWithLink = ({ descriptionPart1, descriptionPart2, link }) => (
    <div className={CN.description}>
      {descriptionPart1}
      <ExternalLink link={VIDEO_LINK} variant="inline">
        <div className={CN.link}>{link}</div>
      </ExternalLink>
      {descriptionPart2}
    </div>
  );

  return (
    <div data-bem="FaqTips" className={CN.component}>
      <div className={CN.title}>{t('composite.slickPayFAQ.title')}</div>
      <div className={CN.container} data-bem="FaqTips__container">
        <FaqItem
          title={t('composite.slickPayFAQ.question1.title')}
          description={renderDescriptionWithLink({
            descriptionPart1: t('composite.slickPayFAQ.question1.descriptionPart1'),
            descriptionPart2: t('composite.slickPayFAQ.question1.descriptionPart2'),
            link: t('common.buttons.here'),
          })}
          isOpen
          variant="full"
        />
        <FaqItem
          title={t('composite.slickPayFAQ.question2.title')}
          description={renderDescription({
            description: t('composite.slickPayFAQ.question2.description'),
          })}
          variant="full"
        />
        <FaqItem
          title={t('composite.slickPayFAQ.question3.title')}
          description={renderDescription({
            description: t('composite.slickPayFAQ.question3.description'),
          })}
          variant="full"
        />
        <FaqItem
          title={t('composite.slickPayFAQ.question4.title')}
          description={renderDescription({
            description: t('composite.slickPayFAQ.question4.description'),
          })}
          variant="full"
        />
        <FaqItem
          title={t('composite.slickPayFAQ.question5.title')}
          description={renderDescription({
            description: t('composite.slickPayFAQ.question5.description'),
          })}
          variant="full"
        />
        <FaqItem
          title={t('composite.slickPayFAQ.question6.title')}
          description={renderDescription({
            description: t('composite.slickPayFAQ.question6.description'),
          })}
          variant="full"
        />
        <FaqItem
          title={t('composite.slickPayFAQ.question7.title')}
          description={renderDescription({
            description: t('composite.slickPayFAQ.question7.description'),
            children: <TablePayment />,
          })}
          variant="full"
        />
        {isSalonWithGDPR && (
          <FaqItem
            title={t('composite.slickPayFAQ.question8.title')}
            description={renderDescription({
              description: t('composite.slickPayFAQ.question8.description'),
            })}
            variant="full"
          />
        )}
      </div>
    </div>
  );
};
export default FaqTips;
